

























































import { ContactContext } from '@spa/components/organisms/contact/model/context/contact-context'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

import ContactItem from '@spa/components/organisms/contact/ContactItem.vue'
import BackToMyPageTopButton from '@spa/components/organisms/mypage/BackToMypPageTopButton.vue'

import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { User } from '@spa/store/modules/user/types'

@Component({
  components: {
    ContactItem,
    BackToMyPageTopButton,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Index extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  context: ContactContext

  status: Status = Status.Pending

  get user(): User {
    return this.$store.state.user.user
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  get errorOnLoad() {
    return _.get(this.$store.state.contact.error, 'load')
  }

  get contacts() {
    // TODO: Need to sort?
    return this.$store.state.contact.items
  }

  get delivery() {
    return this.$store.state.orderConfirm.delivery
  }

  async created() {
    this.status = Status.Loading

    await Promise.all([
      this.$store.dispatch('contact/load'),
      this.$store.dispatch('user/get'),
    ])

    if (this.errorOnLoad) {
      this.status = Status.Failed

      return
    }

    this.status = Status.Completed

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }
}
